import {routerHandler} from "../../../resources/utils/router";
import {ProductViewRoutesData} from "./product-view.routes";
import {StoreViewComponent} from "../../stores/store-view/store-view.component";
import {StoreViewRoutes} from "../../stores/store-view/store-view.routes";
import {ProjectViewComponent} from "../../projects/project-view/project-view.component";
import {ProjectViewRoutes} from "../../projects/project-view/project-view.routes";
import {StoreCollectionViewComponent} from "../../store-collection/store-collection-view/store-collection-view.component";
import {StoreCollectionViewRoutes} from "../../store-collection/store-collection-view/store-collection-view.routes";

export const ProductViewChildrenRoutesData = routerHandler.injectionChildren(ProductViewRoutesData, {
  'info': [
    routerHandler.view('store', {
      component: StoreViewComponent, children: StoreViewRoutes, outer: true, prefix: true
    }),
    routerHandler.view('project', {
      component: ProjectViewComponent, children: ProjectViewRoutes, outer: true, prefix: true
    }),
    routerHandler.view('store-collection', {
      component: StoreCollectionViewComponent, children: StoreCollectionViewRoutes, outer: true, prefix: true
    }),
  ]
});

export const ProductViewChildrenRoutes = Object.values(ProductViewChildrenRoutesData);
